import { StockReportFilterSection } from './stock-report-filter-section';
import { StockReportDepotAndSiteSection } from './stock-report-depot-and-site-section';
import { StockReportCustomerAndContractSection } from './stock-report-customer-and-contract-section';
import { StockReportScaffoldSection } from './stock-report-scaffold-section';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class StockReport {
  DateAndTimeOfReport: string;
  ProgramName: string;
  ProgramVersion: string;
  FilterSection: StockReportFilterSection;
  DepotAndSiteSection: StockReportDepotAndSiteSection;
  CustomerAndContractSection: StockReportCustomerAndContractSection;
  ScaffoldSection: StockReportScaffoldSection;
}


